import * as React from 'react';

import Pill from '../../../LeadsManagement/components/Pill';
import getCheckinStatus from '../../utils/getCheckinStatus';
import * as Style from './style.module.scss';

interface CheckinStatusPillProps {
    status?: string | null;
}

const CheckinStatusPill: React.FC<CheckinStatusPillProps> = ({ status }) => {
    const { label, className } = getCheckinStatus(status);

    return <Pill label={label} className={Style[className]} />;
};

export default CheckinStatusPill;
